import {isEmpty} from 'lodash'
import constants from '@/libs/constant/constants'

export default{
    name: 'AddAuthor',
    components: {
        ClaimedMessage: () => import(/* webpackChunkName: "group-card" */ '@/components/component/ClaimedMessage/ClaimedMessage.vue'),
        ManageAuthor: () => import(/* webpackChunkName: "group-card" */ '../ManageAuthor/ManageAuthor.vue'),
        SearchAuthor: () => import(/* webpackChunkName: "group-card" */ '../SearchAuthor/SearchAuthor.vue'),
        ManageAuthorName: () => import(/* webpackChunkName: "group-card" */ '../ManageAuthorName/ManageAuthorName.vue'),
        ManageAuthorDescription: () => import(/* webpackChunkName: "group-card" */ '../ManageAuthorDescription/ManageAuthorDescription.vue'),
        ManageAuthorImage: () => import(/* webpackChunkName: "group-card" */ '../ManageAuthorImage/ManageAuthorImage.vue'),
        AuthorConfirmation: () => import(/* webpackChunkName: "group-card" */ '../AuthorConfirmation/AuthorConfirmation.vue'),
        AddArticle: () => import(/* webpackChunkName: "group-card" */ '../AddArticle/AddArticle.vue'),
        MaintainAuthor: () => import(/* webpackChunkName: "group-card" */ '../MaintainAuthor/MaintainAuthor.vue')
    },
    beforeMount(){
        if(!isEmpty(this.$store.getters.getClaimTo)){
            this.claimTo = this.$store.getters.getClaimTo
        }
    },
    computed: {
        getFullName: function () {
            let name = this.claimTo.first_name || ''

            if(this.claimTo.middle_name && this.claimTo.middle_name !== ''){
                name = `${name} ${this.claimTo.middle_name}`
            }

            if( this.claimTo.last_name && this.claimTo.last_name !== ''){
                name = `${name} ${this.claimTo.last_name}`
            }

            return name || this.claimTo.name
        }
    },
    data(){
        return {
            termsAndPolicy: false,
            claimTo: {},
            active: 0,
            module: constants.AUTHOR.key,
            isStepBack: false
        }
    },
    methods: {
        stepForward() {
            if (this.active++ > 5) this.active = 0;
        },
        stepBack(){
            this.isStepBack = true
            if (this.active -- < 0) this.active = 0;
        },
        setClaimTo(claimTo){
            this.claimTo = claimTo
        },
        cancel (){
            this.$router.push('card')
        }
    }
}